import { Component, OnInit } from '@angular/core';
import { ErmCapabilityApiClientService, UserSettings, PutUserSettingsRequest } from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  userSettings?: UserSettings;

  isLoading = false;
  isWorking = false;

  constructor(
    private ermCapabilityApiClient: ErmCapabilityApiClientService
  ) { }

  async ngOnInit(): Promise<void> {
    try {
      this.isLoading = true;

      // Get user settings
      const getUserSettingsResponse = await this.ermCapabilityApiClient.getUserSettings();
      this.userSettings = getUserSettingsResponse.body?.userSettings;

    } finally {
      this.isLoading = false;
    }
  }

  async save(): Promise<void> {
    if (this.isWorking) {
      return;
    }
    try {
      this.isWorking = true;
      const request = new PutUserSettingsRequest({
        userSettings: this.userSettings
      });
      await this.ermCapabilityApiClient.putUserSettings(request);
    } finally {
      this.isWorking = false;
    }
  }
}
